/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BigNumberish,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { NenSellerMock, NenSellerMockInterface } from "../NenSellerMock";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_nenToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "_validator",
        type: "address",
      },
      {
        internalType: "uint8",
        name: "_maxMintCountPerTx",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "_whiteListSaleMaxMintCount",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "_reservedMintCount",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "_totalCount",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "isWhitelistSale",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "mintCount",
        type: "uint256",
      },
    ],
    name: "_prepareMessage",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "maxMintCountPerTx",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "isWhitelistSale",
        type: "bool",
      },
      {
        internalType: "uint32",
        name: "mintCount",
        type: "uint32",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "mintNenToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "mintCount",
        type: "uint32",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "mintNenTokenByOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "mintedCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nenToken",
    outputs: [
      {
        internalType: "contract INenToken",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "reservedMaxMintCount",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "reservedMintCount",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "_maxMintCountPerTx",
        type: "uint32",
      },
    ],
    name: "setMaxMintCountPerTx",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nenToken",
        type: "address",
      },
    ],
    name: "setNenToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "_reservedMaxMintCount",
        type: "uint32",
      },
    ],
    name: "setReservedMaxMintCount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_totalCount",
        type: "uint256",
      },
    ],
    name: "setTotalCount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_validator",
        type: "address",
      },
    ],
    name: "setValidator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "_whiteListSaleMaxMintCount",
        type: "uint32",
      },
    ],
    name: "setWhiteListSaleMaxMintCount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "totalCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "validator",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "whiteListSaleMaxMintCount",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type NenSellerMockConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: NenSellerMockConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class NenSellerMock__factory extends ContractFactory {
  constructor(...args: NenSellerMockConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "NenSellerMock";
  }

  deploy(
    _nenToken: string,
    _validator: string,
    _maxMintCountPerTx: BigNumberish,
    _whiteListSaleMaxMintCount: BigNumberish,
    _reservedMintCount: BigNumberish,
    _totalCount: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<NenSellerMock> {
    return super.deploy(
      _nenToken,
      _validator,
      _maxMintCountPerTx,
      _whiteListSaleMaxMintCount,
      _reservedMintCount,
      _totalCount,
      overrides || {}
    ) as Promise<NenSellerMock>;
  }
  getDeployTransaction(
    _nenToken: string,
    _validator: string,
    _maxMintCountPerTx: BigNumberish,
    _whiteListSaleMaxMintCount: BigNumberish,
    _reservedMintCount: BigNumberish,
    _totalCount: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _nenToken,
      _validator,
      _maxMintCountPerTx,
      _whiteListSaleMaxMintCount,
      _reservedMintCount,
      _totalCount,
      overrides || {}
    );
  }
  attach(address: string): NenSellerMock {
    return super.attach(address) as NenSellerMock;
  }
  connect(signer: Signer): NenSellerMock__factory {
    return super.connect(signer) as NenSellerMock__factory;
  }
  static readonly contractName: "NenSellerMock";
  public readonly contractName: "NenSellerMock";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): NenSellerMockInterface {
    return new utils.Interface(_abi) as NenSellerMockInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): NenSellerMock {
    return new Contract(address, _abi, signerOrProvider) as NenSellerMock;
  }
}
